import { UserProfile } from '@/components/User/UserProvider/UserProvider'
import { parseXOMembershipToken } from '@/utils/pages'
import MembershipService from '@xo-union/sdk-membership'
import { GetServerSidePropsContext } from 'next'
import fetch, { Headers } from 'node-fetch'

const TkMembershipApiVersion = 'v2'

export const clientOptions = {
  env: process.env.UNION_DEPLOYMENT_ENV,
  host: process.env.UNION_MEMBERSHIP_HOST,
  apiKey: process.env.NEXT_PUBLIC_UNION_MEMBERSHIP_API_KEY,
  version: TkMembershipApiVersion,
}

const membershipServiceClient = new MembershipService({ clientOptions })

export default membershipServiceClient

export const getUserTK = async (cookie: string): Promise<UserProfile | null> => {
  const path = `${process.env.UNION_MEMBERSHIP_HOST}/members?apikey=${process.env.NEXT_PUBLIC_UNION_MEMBERSHIP_API_KEY}`
  const token = parseXOMembershipToken(cookie || '') as string

  if (!token) return null

  const headers = new Headers()

  headers.append('Accept-Version', TkMembershipApiVersion)
  headers.append('Content-Type', 'application/json')
  headers.append('MEMBERSHIP-SESSION-TOKEN', token)

  try {
    const response = await fetch(path, {
      headers,
    })
    const user = await response.json()
    return {
      id: user.members.id,
      username: '',
      email: user.members.email,
      firstName: '',
      lastName: '',
      avatar: {
        url: '',
        color: '',
      },
      unreadMessagesCount: '0',
    }
  } catch (e) {
    return null
  }
}

async function getUserWW(context: GetServerSidePropsContext): Promise<UserProfile | null> {
  const { cookies, headers } = context.req
  const {
    UC: uc,
    USER_ID: userId,
    USER_TIPO: userTipo,
    'tkww-access-token': accessToken,
    'tkww-refresh-token': refreshToken,
  } = cookies
  const ua = headers['user-agent'] || headers['User-Agent']
  const apiToken = String(process.env.BP_API_TOKEN)

  let sessionCookie = ''

  if (uc !== null) sessionCookie += `UC=${uc};`
  if (userId !== null) sessionCookie += `USER_ID=${userId};`
  if (userTipo !== null) sessionCookie += `USER_TIPO=${userTipo};`
  if (accessToken !== null) sessionCookie += `tkww-access-token=${accessToken};`
  if (refreshToken !== null) sessionCookie += `tkww-refresh-token=${refreshToken};`

  try {
    const userResponse = await fetch(
      `${process.env.AUTH_API_BASE}/userprofile/v1/user?fields=id,email,username,first_name,last_name,avatar,num_unread_msgs`,
      {
        headers: {
          'x-app-partner-key': apiToken,
          'x-app-session-cookie': sessionCookie,
          'x-app-user-agent': ua as string,
        },
      }
    )

    if (userResponse.ok) {
      const user = await userResponse.json()

      return {
        id: user.id,
        username: user.username,
        email: user.email,
        firstName: user.first_name,
        lastName: user.last_name,
        avatar: {
          url: user.avatar.img,
          color: user.avatar.color,
        },
        unreadMessagesCount: user.num_unread_msgs,
      }
    }
    return null
  } catch (e) {
    return null
  }
}

export async function getUserProfile(context: GetServerSidePropsContext): Promise<UserProfile | null> {
  return process.env.APP_BRAND === 'ww' ? getUserWW(context) : getUserTK(context?.req?.headers?.cookie || '')
}
